// 신뢰 배지 + 파트너 로고 + 실시간 사용자 수
import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useT } from '../lib/i18n'
import type { TranslationKey } from '../locales/ko'

const PARTNERS = [
  { name: 'Uniflow-ERP', icon: 'server' as const },
  { name: 'Mitutoyo',    icon: 'ruler-combined' as const },
  { name: 'Zeiss',       icon: 'cubes' as const },
  { name: 'OPC-UA',      icon: 'tower-broadcast' as const },
  { name: 'Cloudflare',  icon: 'shield-halved' as const },
]

const TRUST_BADGES: Array<{ icon: any; key: TranslationKey }> = [
  { icon: 'shield-halved', key: 'trust.iso' },
  { icon: 'lock',          key: 'trust.encryption' },
  { icon: 'circle-check',  key: 'trust.audit' },
]

export function SocialProof() {
  const { t } = useT()
  const [online, setOnline] = useState(38)
  useEffect(() => {
    const id = setInterval(
      () => setOnline((v) => Math.max(12, v + (Math.random() < 0.5 ? -1 : 1))),
      2400,
    )
    return () => clearInterval(id)
  }, [])

  return (
    <section className="container stack" aria-labelledby="trust-h" style={{ paddingBlock: '1.5rem' }}>
      <h2 id="trust-h" className="sr-only">{t('common.notifications')}</h2>

      <div className="row" style={{ gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
        {TRUST_BADGES.map((b) => (
          <span key={b.key} className="badge info">
            <FontAwesomeIcon icon={b.icon} aria-hidden="true" /> {t(b.key)}
          </span>
        ))}
        <span className="badge success" aria-live="polite">
          <span className="dot" aria-hidden="true" />
          {t('trust.online', { n: online })}
        </span>
      </div>

      <div className="logo-row" aria-label="Partners">
        {PARTNERS.map((p) => (
          <span key={p.name} className="logo">
            <FontAwesomeIcon icon={p.icon} aria-hidden="true" /> {p.name}
          </span>
        ))}
      </div>
    </section>
  )
}
